import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Employee  {
    _originalTypeClassName = "zERP.BO.Employee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Employee.translate = translateService;
}
this.Certification = [];
this.EducationalQualifications = [];
this.PastWorkExpirience = [];
this.EmergencyContacts = [];
this.Documents = [];
this.DepedentMember = [];
this.Payments = [];
this.Contracts = [];
this.MeetingToAttend = [];
this.ForeignLanguange = [];
this.VocationalEducation = [];
this.Id = null;
this.Code = null;
this.FirstName = null;
this.LastName = null;
this.FatherName = null;
this.FatherSurname = null;
this.MotherName = null;
this.MotherSurname = null;
this.Fullname = null;
this.DateOfBirth = null;
this.PlaceOfBirth = null;
this.Gender = null;
this.FamilyStatus = null;
this.SpouseName = null;
this.ChildrenCount = 0;
this.PhoneNumber = null;
this.MobilePhoneNumber = null;
this.Email = null;
this.DocumentType = null;
this.DocumentId = null;
this.DocumentAuthority = null;
this.DocumentIssueDate = null;
this.DocumentExpirationDate = null;
this.PassportId = null;
this.IBAN = null;
this.TaxNumber = null;
this.SocialSecurityNumber = null;
this.SocialRegistryNumber = null;
this.SecondarySocialRegistryNumber = null;
this.FirstInsuranceDate = null;
this.UnemploymentCardNumber = null;
this.HasUnemploymentBenefit = false;
this.NewlyInsured = false;
this.MilitaryObligations = null;
this.DeferralExpires = null;
this.ExternalID = null;
this.WorkPermitNumber = null;
this.WorkPermitFrom = null;
this.WorkPermitTo = null;
this.EmailBusiness = null;
this.AccountNumber = null;
this.AccountHolder = null;
this.BusinessPhone = null;
this.InternalPhone = null;
this.HasContract = false;
this.DocumentTypePhoto = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.PersonalNumber = null;
this.FamilyProvisionChildren = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
FirstName:any;
LastName:any;
FatherName:any;
FatherSurname:any;
MotherName:any;
MotherSurname:any;
Fullname:any;
DateOfBirth:any;
PlaceOfBirth:any;
Gender:any;
FamilyStatus:any;
SpouseName:any;
ChildrenCount:any;
PhoneNumber:any;
MobilePhoneNumber:any;
Email:any;
DocumentType:any;
DocumentId:any;
DocumentAuthority:any;
DocumentIssueDate:any;
DocumentExpirationDate:any;
PassportId:any;
IBAN:any;
TaxNumber:any;
SocialSecurityNumber:any;
SocialRegistryNumber:any;
SecondarySocialRegistryNumber:any;
FirstInsuranceDate:any;
UnemploymentCardNumber:any;
HasUnemploymentBenefit:any;
NewlyInsured:any;
MilitaryObligations:any;
DeferralExpires:any;
ExternalID:any;
WorkPermitNumber:any;
WorkPermitFrom:any;
WorkPermitTo:any;
EmailBusiness:any;
AccountNumber:any;
AccountHolder:any;
BusinessPhone:any;
InternalPhone:any;
HasContract:any;
DocumentTypePhoto:any;
DocumentDescription:any;
DocumentPath:any;
PersonalNumber:any;
FamilyProvisionChildren:any;
Certification:any;
WorkPermitCountry:any;
DocumentIssueCountry:any;
Citizenship:any;
Nationality:any;
Bank:any;
TaxOffice:any;
Address:any;
EducationalQualifications:any;
PastWorkExpirience:any;
EmergencyContacts:any;
Photo:any;
UserAccount:any;
WorkExperienceAnalysis:any;
DayOffExperienceAnalysis:any;
CTExperienceAnalysis:any;
Documents:any;
DepedentMember:any;
GroupEmployee:any;
Ergani_Nationality:any;
Ergani_Taytotita:any;
Ergani_DOY:any;
Ergani_DimotikiEnotita:any;
ErganiForeignFile:any;
ErganiYoungFile:any;
Allowance:any;
EmploymentOffice:any;
Payments:any;
Contracts:any;
MeetingToAttend:any;
ForeignLanguange:any;
VocationalEducation:any;
static setCertification = ($this, items) => {
                if (items == null) items = [];
                if ($this.Certification == null) $this.Certification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Certification.length > 0) {
                    Domain.Employee.removeCertification($this, $this.Certification[0]);
                }

                Domain.Employee.addManyCertification($this, copyItems);
            }
static addManyCertification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addCertification($this, items[i]);
                }
            }
static addCertification = ($this, item) => {
                if ($this.Certification == null) $this.Certification = [];
                if (item == null || $this.Certification.indexOf(item) > -1) return;
                $this.Certification.push(item);
if (item.Employee != $this) {
Domain.Certification.setEmployee(item, $this);
}
}
static addRangeCertification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addCertification($this, item));
            }
static removeCertification = ($this, item) => {
                if ($this == null || $this.Certification == null || $this.Certification.indexOf(item) === -1) return;
                var _index = $this.Certification.indexOf(item);
                $this.Certification.splice(_index, 1);
item.Employee = null;
}
static clearCertification = ($this) => { $this.Certification = null; }
static setWorkPermitCountry = ($this, value) => {
var oldValue = $this.WorkPermitCountry;
$this.WorkPermitCountry = value;
if (value != null) {
}
}
static setDocumentIssueCountry = ($this, value) => {
var oldValue = $this.DocumentIssueCountry;
$this.DocumentIssueCountry = value;
if (value != null) {
}
}
static setCitizenship = ($this, value) => {
var oldValue = $this.Citizenship;
$this.Citizenship = value;
if (value != null) {
}
}
static setNationality = ($this, value) => {
var oldValue = $this.Nationality;
$this.Nationality = value;
if (value != null) {
}
}
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
}
}
static setTaxOffice = ($this, value) => {
var oldValue = $this.TaxOffice;
$this.TaxOffice = value;
if (value != null) {
}
}
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setEducationalQualifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.EducationalQualifications == null) $this.EducationalQualifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EducationalQualifications.length > 0) {
                    Domain.Employee.removeEducationalQualifications($this, $this.EducationalQualifications[0]);
                }

                Domain.Employee.addManyEducationalQualifications($this, copyItems);
            }
static addManyEducationalQualifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addEducationalQualifications($this, items[i]);
                }
            }
static addEducationalQualifications = ($this, item) => {
                if ($this.EducationalQualifications == null) $this.EducationalQualifications = [];
                if (item == null || $this.EducationalQualifications.indexOf(item) > -1) return;
                $this.EducationalQualifications.push(item);
if (item.Employee != $this) {
Domain.EducationalQualification.setEmployee(item, $this);
}
}
static addRangeEducationalQualifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addEducationalQualifications($this, item));
            }
static removeEducationalQualifications = ($this, item) => {
                if ($this == null || $this.EducationalQualifications == null || $this.EducationalQualifications.indexOf(item) === -1) return;
                var _index = $this.EducationalQualifications.indexOf(item);
                $this.EducationalQualifications.splice(_index, 1);
item.Employee = null;
}
static clearEducationalQualifications = ($this) => { $this.EducationalQualifications = null; }
static setPastWorkExpirience = ($this, items) => {
                if (items == null) items = [];
                if ($this.PastWorkExpirience == null) $this.PastWorkExpirience = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PastWorkExpirience.length > 0) {
                    Domain.Employee.removePastWorkExpirience($this, $this.PastWorkExpirience[0]);
                }

                Domain.Employee.addManyPastWorkExpirience($this, copyItems);
            }
static addManyPastWorkExpirience = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addPastWorkExpirience($this, items[i]);
                }
            }
static addPastWorkExpirience = ($this, item) => {
                if ($this.PastWorkExpirience == null) $this.PastWorkExpirience = [];
                if (item == null || $this.PastWorkExpirience.indexOf(item) > -1) return;
                $this.PastWorkExpirience.push(item);
if (item.Employee != $this) {
Domain.WorkExperience.setEmployee(item, $this);
}
}
static addRangePastWorkExpirience = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addPastWorkExpirience($this, item));
            }
static removePastWorkExpirience = ($this, item) => {
                if ($this == null || $this.PastWorkExpirience == null || $this.PastWorkExpirience.indexOf(item) === -1) return;
                var _index = $this.PastWorkExpirience.indexOf(item);
                $this.PastWorkExpirience.splice(_index, 1);
item.Employee = null;
}
static clearPastWorkExpirience = ($this) => { $this.PastWorkExpirience = null; }
static setEmergencyContacts = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmergencyContacts == null) $this.EmergencyContacts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmergencyContacts.length > 0) {
                    Domain.Employee.removeEmergencyContacts($this, $this.EmergencyContacts[0]);
                }

                Domain.Employee.addManyEmergencyContacts($this, copyItems);
            }
static addManyEmergencyContacts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addEmergencyContacts($this, items[i]);
                }
            }
static addEmergencyContacts = ($this, item) => {
                if ($this.EmergencyContacts == null) $this.EmergencyContacts = [];
                if (item == null || $this.EmergencyContacts.indexOf(item) > -1) return;
                $this.EmergencyContacts.push(item);
}
static addRangeEmergencyContacts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addEmergencyContacts($this, item));
            }
static removeEmergencyContacts = ($this, item) => {
                if ($this == null || $this.EmergencyContacts == null || $this.EmergencyContacts.indexOf(item) === -1) return;
                var _index = $this.EmergencyContacts.indexOf(item);
                $this.EmergencyContacts.splice(_index, 1);
}
static clearEmergencyContacts = ($this) => { $this.EmergencyContacts = null; }
static setPhoto = ($this, value) => {
var oldValue = $this.Photo;
$this.Photo = value;
if (value != null) {
}
}
static setUserAccount = ($this, value) => {
var oldValue = $this.UserAccount;
$this.UserAccount = value;
if (value != null) {
if (oldValue != null && oldValue.Employee != null) { oldValue.Employee = null; }
if ($this.UserAccount.Employee !== $this) {
Domain.UserAccount.setEmployee(value, $this);
}
}
}
static setWorkExperienceAnalysis = ($this, value) => {
var oldValue = $this.WorkExperienceAnalysis;
$this.WorkExperienceAnalysis = value;
if (value != null) {
}
}
static setDayOffExperienceAnalysis = ($this, value) => {
var oldValue = $this.DayOffExperienceAnalysis;
$this.DayOffExperienceAnalysis = value;
if (value != null) {
}
}
static setCTExperienceAnalysis = ($this, value) => {
var oldValue = $this.CTExperienceAnalysis;
$this.CTExperienceAnalysis = value;
if (value != null) {
}
}
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.Employee.removeDocuments($this, $this.Documents[0]);
                }

                Domain.Employee.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
if (item.Employee != $this) {
Domain.EmployeeDocument.setEmployee(item, $this);
}
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
item.Employee = null;
}
static clearDocuments = ($this) => { $this.Documents = null; }
static setDepedentMember = ($this, items) => {
                if (items == null) items = [];
                if ($this.DepedentMember == null) $this.DepedentMember = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DepedentMember.length > 0) {
                    Domain.Employee.removeDepedentMember($this, $this.DepedentMember[0]);
                }

                Domain.Employee.addManyDepedentMember($this, copyItems);
            }
static addManyDepedentMember = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addDepedentMember($this, items[i]);
                }
            }
static addDepedentMember = ($this, item) => {
                if ($this.DepedentMember == null) $this.DepedentMember = [];
                if (item == null || $this.DepedentMember.indexOf(item) > -1) return;
                $this.DepedentMember.push(item);
if (item.Employee != $this) {
Domain.DepedentMember.setEmployee(item, $this);
}
}
static addRangeDepedentMember = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addDepedentMember($this, item));
            }
static removeDepedentMember = ($this, item) => {
                if ($this == null || $this.DepedentMember == null || $this.DepedentMember.indexOf(item) === -1) return;
                var _index = $this.DepedentMember.indexOf(item);
                $this.DepedentMember.splice(_index, 1);
item.Employee = null;
}
static clearDepedentMember = ($this) => { $this.DepedentMember = null; }
static setGroupEmployee = ($this, value) => {
var oldValue = $this.GroupEmployee;
$this.GroupEmployee = value;
if (value != null) {
}
}
static setErgani_Nationality = ($this, value) => {
var oldValue = $this.Ergani_Nationality;
$this.Ergani_Nationality = value;
if (value != null) {
}
}
static setErgani_Taytotita = ($this, value) => {
var oldValue = $this.Ergani_Taytotita;
$this.Ergani_Taytotita = value;
if (value != null) {
}
}
static setErgani_DOY = ($this, value) => {
var oldValue = $this.Ergani_DOY;
$this.Ergani_DOY = value;
if (value != null) {
}
}
static setErgani_DimotikiEnotita = ($this, value) => {
var oldValue = $this.Ergani_DimotikiEnotita;
$this.Ergani_DimotikiEnotita = value;
if (value != null) {
}
}
static setErganiForeignFile = ($this, value) => {
var oldValue = $this.ErganiForeignFile;
$this.ErganiForeignFile = value;
if (value != null) {
}
}
static setErganiYoungFile = ($this, value) => {
var oldValue = $this.ErganiYoungFile;
$this.ErganiYoungFile = value;
if (value != null) {
}
}
static setAllowance = ($this, value) => {
var oldValue = $this.Allowance;
$this.Allowance = value;
if (value != null) {
}
}
static setEmploymentOffice = ($this, value) => {
var oldValue = $this.EmploymentOffice;
$this.EmploymentOffice = value;
if (value != null) {
}
}
static setPayments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Payments == null) $this.Payments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Payments.length > 0) {
                    Domain.Employee.removePayments($this, $this.Payments[0]);
                }

                Domain.Employee.addManyPayments($this, copyItems);
            }
static addManyPayments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addPayments($this, items[i]);
                }
            }
static addPayments = ($this, item) => {
                if ($this.Payments == null) $this.Payments = [];
                if (item == null || $this.Payments.indexOf(item) > -1) return;
                $this.Payments.push(item);
if (item.Employee != $this) {
Domain.EmployeePayroll.setEmployee(item, $this);
}
}
static addRangePayments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addPayments($this, item));
            }
static removePayments = ($this, item) => {
                if ($this == null || $this.Payments == null || $this.Payments.indexOf(item) === -1) return;
                var _index = $this.Payments.indexOf(item);
                $this.Payments.splice(_index, 1);
item.Employee = null;
}
static clearPayments = ($this) => { $this.Payments = null; }
static setContracts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contracts == null) $this.Contracts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contracts.length > 0) {
                    Domain.Employee.removeContracts($this, $this.Contracts[0]);
                }

                Domain.Employee.addManyContracts($this, copyItems);
            }
static addManyContracts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addContracts($this, items[i]);
                }
            }
static addContracts = ($this, item) => {
                if ($this.Contracts == null) $this.Contracts = [];
                if (item == null || $this.Contracts.indexOf(item) > -1) return;
                $this.Contracts.push(item);
if (item.Employee != $this) {
Domain.EmployeeContract.setEmployee(item, $this);
}
}
static addRangeContracts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addContracts($this, item));
            }
static removeContracts = ($this, item) => {
                if ($this == null || $this.Contracts == null || $this.Contracts.indexOf(item) === -1) return;
                var _index = $this.Contracts.indexOf(item);
                $this.Contracts.splice(_index, 1);
item.Employee = null;
}
static clearContracts = ($this) => { $this.Contracts = null; }
static setMeetingToAttend = ($this, items) => {
                if (items == null) items = [];
                if ($this.MeetingToAttend == null) $this.MeetingToAttend = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MeetingToAttend.length > 0) {
                    Domain.Employee.removeMeetingToAttend($this, $this.MeetingToAttend[0]);
                }

                Domain.Employee.addManyMeetingToAttend($this, copyItems);
            }
static addManyMeetingToAttend = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addMeetingToAttend($this, items[i]);
                }
            }
static addMeetingToAttend = ($this, item) => {
                if ($this.MeetingToAttend == null) $this.MeetingToAttend = [];
                if (item == null || $this.MeetingToAttend.indexOf(item) > -1) return;
                $this.MeetingToAttend.push(item);
if (item.Attendee != $this) {
Domain.MemberAttendance.setAttendee(item, $this);
}
}
static addRangeMeetingToAttend = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addMeetingToAttend($this, item));
            }
static removeMeetingToAttend = ($this, item) => {
                if ($this == null || $this.MeetingToAttend == null || $this.MeetingToAttend.indexOf(item) === -1) return;
                var _index = $this.MeetingToAttend.indexOf(item);
                $this.MeetingToAttend.splice(_index, 1);
item.Attendee = null;
}
static clearMeetingToAttend = ($this) => { $this.MeetingToAttend = null; }
static setForeignLanguange = ($this, items) => {
                if (items == null) items = [];
                if ($this.ForeignLanguange == null) $this.ForeignLanguange = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ForeignLanguange.length > 0) {
                    Domain.Employee.removeForeignLanguange($this, $this.ForeignLanguange[0]);
                }

                Domain.Employee.addManyForeignLanguange($this, copyItems);
            }
static addManyForeignLanguange = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addForeignLanguange($this, items[i]);
                }
            }
static addForeignLanguange = ($this, item) => {
                if ($this.ForeignLanguange == null) $this.ForeignLanguange = [];
                if (item == null || $this.ForeignLanguange.indexOf(item) > -1) return;
                $this.ForeignLanguange.push(item);
if (item.Employee != $this) {
Domain.ForeignLanguange.setEmployee(item, $this);
}
}
static addRangeForeignLanguange = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addForeignLanguange($this, item));
            }
static removeForeignLanguange = ($this, item) => {
                if ($this == null || $this.ForeignLanguange == null || $this.ForeignLanguange.indexOf(item) === -1) return;
                var _index = $this.ForeignLanguange.indexOf(item);
                $this.ForeignLanguange.splice(_index, 1);
item.Employee = null;
}
static clearForeignLanguange = ($this) => { $this.ForeignLanguange = null; }
static setVocationalEducation = ($this, items) => {
                if (items == null) items = [];
                if ($this.VocationalEducation == null) $this.VocationalEducation = [];

                const copyItems = Common.cloneObject(items);

                while ($this.VocationalEducation.length > 0) {
                    Domain.Employee.removeVocationalEducation($this, $this.VocationalEducation[0]);
                }

                Domain.Employee.addManyVocationalEducation($this, copyItems);
            }
static addManyVocationalEducation = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Employee.addVocationalEducation($this, items[i]);
                }
            }
static addVocationalEducation = ($this, item) => {
                if ($this.VocationalEducation == null) $this.VocationalEducation = [];
                if (item == null || $this.VocationalEducation.indexOf(item) > -1) return;
                $this.VocationalEducation.push(item);
if (item.Employee != $this) {
Domain.VocationalEducation.setEmployee(item, $this);
}
}
static addRangeVocationalEducation = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Employee.addVocationalEducation($this, item));
            }
static removeVocationalEducation = ($this, item) => {
                if ($this == null || $this.VocationalEducation == null || $this.VocationalEducation.indexOf(item) === -1) return;
                var _index = $this.VocationalEducation.indexOf(item);
                $this.VocationalEducation.splice(_index, 1);
item.Employee = null;
}
static clearVocationalEducation = ($this) => { $this.VocationalEducation = null; }

static CalculateFamilyProvision($this: any): any{let lastScaleAmount = 170;
let provisionAmount = null;
if (CLMS.Framework.Number.LessThanOrEqual(() => $this.FamilyProvisionChildren, () => 4)) {switch ($this?.FamilyProvisionChildren) {case 0:
{
provisionAmount = 0;break;}
case 1:
{
provisionAmount = 50;break;}
case 2:
{
provisionAmount = 70;break;}
case 3:
{
provisionAmount = 120;break;}
case 4:
{
provisionAmount = 170;break;}
}}else {provisionAmount = Joove.Common.safeNumber(lastScaleAmount) + Joove.Common.safeNumber((Joove.Common.safeNumber($this?.FamilyProvisionChildren) - Joove.Common.safeNumber(4))) * Joove.Common.safeNumber(70);}
return provisionAmount;
}
static GetActiveContract($this: any): any{if (!($this?.Contracts?.linq?.any())) {return null;}
return $this?.Contracts?.linq?.where((c) => c?.IsActive)?.firstOrDefault(null);
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetDependentMembers($this: any): any{console.warn("++++++++++++");
return $this?.DepedentMember;
}
static GetEmployeeHasHidePermision($this: any): any{if (window._context.currentUserPermissions.indexOf("hideContractInfo") > -1 == true) {for (let _icont = 0; _icont < ($this?.Contracts == null ? 0 : $this?.Contracts.length); _icont++) {let cont = $this?.Contracts[_icont];cont.SalaryNew = "*****";}}else {for (let _icont = 0; _icont < ($this?.Contracts == null ? 0 : $this?.Contracts.length); _icont++) {let cont = $this?.Contracts[_icont];cont.SalaryNew = "*****";}}
}
static GetFullname($this: any): any{return $this?.LastName + " " + $this?.FirstName;
}
static GetSupervisors(dep: any): any{let result = [];
if (Domain.Department.IsNew(dep)) {return result;}
if (!(Domain.Employee.IsNew(dep?.Supervisor))) {result?.add(dep?.Supervisor);}
let parentDep = dep?.Parent;
while (!(Domain.Department.IsNew(parentDep))) {let parentSupervisor = parentDep?.Supervisor;if (!(Domain.Employee.IsNew(parentDep?.Supervisor))) {if (!(result?.linq?.contains(parentSupervisor))) {result?.add(parentSupervisor);}}parentDep = parentDep?.Parent;}
console.warn("GetSupervisors:" + Joove.Common.safeNumber(result?.length));
return result;
}
static RecalculateContractTerminationExpirience($this: any): any{let pastExperience = $this?.PastWorkExpirience?.linq?.where((p) => p?.AcknowledgeContractTermination)?.toArray();
if ($this?.CTExperienceAnalysis == null) {Domain.Employee.setCTExperienceAnalysis($this, new Domain.WorkExperienceAnalysis());}
Domain.Employee.RecalculateExperience($this, $this?.CTExperienceAnalysis, pastExperience);
}
static RecalculateDayOffsExpirience($this: any): any{let pastExperience = $this?.PastWorkExpirience?.linq?.where((p) => p?.AcknowledgeDayOffs)?.toArray();
if ($this?.DayOffExperienceAnalysis == null) {Domain.Employee.setDayOffExperienceAnalysis($this, new Domain.WorkExperienceAnalysis());}
Domain.Employee.RecalculateExperience($this, $this?.DayOffExperienceAnalysis, pastExperience);
}
static RecalculateExperience($this: any, analysis: any,pastExperience: any): any{analysis.ExperienceInYears = (pastExperience?.linq?.any() ? pastExperience?.linq?.sum((p) => p?.ExperienceYears) : 0);
analysis.ExperienceInMonths = (pastExperience?.linq?.any() ? pastExperience?.linq?.sum((p) => p?.ExperienceMonths) : 0);
analysis.ExperienceInDays = (pastExperience?.linq?.any() ? pastExperience?.linq?.sum((p) => p?.ExperienceDays) : 0);
if (CLMS.Framework.Number.GreaterThan(() => analysis.ExperienceInDays, () => 30)) {let newMonths = parseInt((Math.floor(Joove.Common.safeNumber((parseFloat((analysis?.ExperienceInDays) as any))) / Joove.Common.safeNumber(30))) as any);analysis.ExperienceInMonths = Joove.Common.safeNumber(analysis?.ExperienceInMonths) + Joove.Common.safeNumber(newMonths);analysis.ExperienceInDays = Joove.Common.safeNumber(analysis?.ExperienceInDays) - Joove.Common.safeNumber((Joove.Common.safeNumber(newMonths) * Joove.Common.safeNumber(30)));}
if (CLMS.Framework.Number.GreaterThan(() => analysis.ExperienceInMonths, () => 12)) {let newYears = parseInt((Math.floor(Joove.Common.safeNumber((parseFloat((analysis?.ExperienceInMonths) as any))) / Joove.Common.safeNumber(12))) as any);analysis.ExperienceInYears = Joove.Common.safeNumber(analysis?.ExperienceInYears) + Joove.Common.safeNumber(newYears);analysis.ExperienceInMonths = Joove.Common.safeNumber(analysis?.ExperienceInMonths) - Joove.Common.safeNumber((Joove.Common.safeNumber(newYears) * Joove.Common.safeNumber(12)));}
}
static RecalculateMilitaryFullfilled($this: any): any{}
static RecalculateWorkExpirience($this: any): any{let pastExperience = $this?.PastWorkExpirience?.linq?.where((p) => p?.AcknowledgeSalary)?.toArray();
if ($this?.WorkExperienceAnalysis == null) {Domain.Employee.setWorkExperienceAnalysis($this, new Domain.WorkExperienceAnalysis());}
Domain.Employee.RecalculateExperience($this, $this?.WorkExperienceAnalysis, pastExperience);
}
static returnDocumentTypeGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Αστυνομική Ταυτότητα" : "Διαβατήριο");
}
static returnDocumentTypeIndex(dt: any): any{return (dt == Domain.DocumentType.IdCard ? 0 : 1);
}
static returnDocumentTypeValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.DocumentType.IdCard : Domain.DocumentType.Passport);
}
static returnFamilyStatusGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Άγαμος/η" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Έγγαμος/η" : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? "Διαζευγμένος/η" : "Χήρος/α")))));
}
static returnFamilyStatusIndex(fs: any): any{return (fs == Domain.FamilyStatus.Single ? 0 : ((fs == Domain.FamilyStatus.Married ? 1 : ((fs == Domain.FamilyStatus.Divorced ? 2 : 3)))));
}
static returnFamilyStatusValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.FamilyStatus.Single : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.FamilyStatus.Married : ((CLMS.Framework.Number.Equal(() => index, () => 2) ? Domain.FamilyStatus.Divorced : Domain.FamilyStatus.Widowed)))));
}
static returnMilitaryObligationsGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Ναι" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Όχι" : "Δεν Απαιτείται")));
}
static returnMilitaryObligationsIndex(mil: any): any{return (mil == Domain.MilitaryObligations.Yes ? 0 : ((mil == Domain.MilitaryObligations.No ? 1 : 2)));
}
static returnMilitaryObligationsValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? Domain.MilitaryObligations.Yes : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? Domain.MilitaryObligations.No : Domain.MilitaryObligations.NotRequired)));
}
static UpdateExpirience($this: any): any{Domain.Employee.RecalculateWorkExpirience($this);
Domain.Employee.RecalculateDayOffsExpirience($this);
Domain.Employee.RecalculateContractTerminationExpirience($this);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}